import React from 'react';
import './index.less'

const Navigation = (props) => {
  const { logo, list = [], active } = props

  return <div className="navbar">
    <div className="navbar-inner">
      {
        logo
          ? <img src={logo} alt="logo" />
          : null
      }
      <ul className="navbar-inner-list">
        {
          list.map((item, index) => {
            return <li key={index} className={`${active === index ? "nav-li nav-active" : "nav-li"}`}>
              <a href={item.path}>{item.name}</a>
            </li>
          })
        }
      </ul>
    </div>
  </div>
}



export default Navigation
